import React from 'react';
import Route from 'react-router/lib/Route';
import IndexRoute from 'react-router/lib/IndexRoute';

import * as hooks from '../../auth/routerHooks';
import DeletedStaffPage from './deleted/DeletedStaffPageContainer';
import AddStaff from './staffForm/AddStaff';
import StaffList from './staffList';
import EditStaff from './staffForm/EditStaff';

const StaffManagementRoutes = store => (
  <Route path="staff" name="staff">
    <IndexRoute component={StaffList} onEnter={hooks.requireStaffManagementAvailability(store)} />
    <Route
      path="deleted"
      name="staff.deleted"
      onEnter={hooks.requireDeletedStaffListAvailability(store)}
      component={DeletedStaffPage}
    />
    <Route
      path="add"
      name="staff.add"
      onEnter={hooks.requireStaffManagementAvailability(store)}
      component={AddStaff}
    />
    <Route
      path=":staffId"
      name="staff.details"
      onEnter={hooks.requireStaffManagementAvailability(store)}
      component={EditStaff}
    />
  </Route>
);

export default StaffManagementRoutes;
